import { render, staticRenderFns } from "./MyProfileTechnicalSupport.vue?vue&type=template&id=a2f450a0&scoped=true"
import script from "./MyProfileTechnicalSupport.vue?vue&type=script&lang=js"
export * from "./MyProfileTechnicalSupport.vue?vue&type=script&lang=js"
import style0 from "./MyProfileTechnicalSupport.vue?vue&type=style&index=0&id=a2f450a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f450a0",
  null
  
)

export default component.exports